module.exports = __webpack_public_path__ + "img/banner.ced45425.png";